import script from "./ProgramOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramOverview.vue?vue&type=script&setup=true&lang=js"

import "./ProgramOverview.vue?vue&type=style&index=0&id=b089be7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b089be7e"]])

export default __exports__